<template>
	<div>
		
		<layout>

			<template v-slot:title> 
				CUENTAS API
			</template>

			<template v-slot:subtitle> 
				CUENTAS API
			</template>


			<template v-slot:content>
				
				<v-container>

					<v-card class="pa-5" light>

						<!-- porcentaje de utilidad -->
						<form @submit.prevent="updatePercUtility()">
							<v-row>
								<v-col md="2">
									<v-text-field 
										label="% de utilidad" 
										outlined 
										required 
										dense
										v-model="percUtility">
									</v-text-field>
								</v-col>
								<v-col md="1">
									<v-btn type="submit" dark>Actualizar</v-btn>
								</v-col>
							</v-row>
						</form>
						

				    <v-card-title>
				      <v-text-field
				        v-model="search"
				        append-icon="mdi-magnify"
				        label="Buscar"
				        single-line
				        hide-details
				      ></v-text-field>
				    </v-card-title>
				    
				    <v-data-table
				      :headers="headers"
				      :items="accounts"
				      :search="search"
				    >

  			    	<template v-slot:item.number="{ item }">
  			    		<span style="font-weight: 600">{{ item.number }}</span>
  			    	</template>


				    	<template v-slot:item.options="{ item }">
				    		
				    		<div class="d-flex">
					    		<v-switch
					    			v-model="item.status"
					    			@change="updateStatus(item)"
			    		    ></v-switch>

			    		    <v-btn 
					    			class="ml-3 mt-4" 
					    			color="primary"
					    			small
					    			@click="edit(item.id)"
					    		>
					    			<v-icon class="me-1" small>mdi-pencil</v-icon>
					    			Editar cantidad
					    		</v-btn>
				    		</div>

				    	</template>


				    </v-data-table>

					</v-card>

				</v-container>
				

				<!-- modal edit -->
				<v-dialog
					light
		      v-model="openModalEdit"
		      persistent
		      max-width="600px"
		      style="z-index: 2000;"
		    >
		      <v-card>
		        
		        <v-card-title>
		          <span class="text-h6">Editar cantidad</span> 
		          <v-btn
                icon
                @click="openModalEdit = false"
                style="position: absolute;right: 0px;"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
		        </v-card-title>

		        <v-card-text>
		          <v-container>    

		          	<form @submit.prevent="update()">

		          		<v-text-field
		          		  label="Código"
		          		  v-model="account.code" 
		          		  filled
		          		  light
		          		  disabled
		          		></v-text-field>

		          		<v-text-field
		          			type="number"
		          		  label="Cantidad"
		          		  v-model="account.number" 
		          		  filled
		          		  light
		          		  required
		          		></v-text-field>

		          		<v-btn type="submit" dark color="primary">
		          			Actualizar 
	          			</v-btn>

		          	</form>

		          </v-container>
		        </v-card-text>


		      </v-card>
		    </v-dialog>
		    <!--/ modal edit -->


		  </template>
		</layout>


	</div>
</template>


<script>
	
	import Layout from './../../layout/Layout'

	import AccountsApiService from '@/shared/services/AccountsApiService'


	export default
	{

		data() {
			return {
				accounts: [],

				search: '',
        headers: [
          { text: 'Código de la cuenta', align: 'start', value: 'code', sortable: false },
          { text: 'Descripción ', value: 'description', sortable: false },
          { text: 'Cantidad', value: 'number', sortable: false },
          { text: '', value: 'options', sortable: false },
        ],

        percUtility: null,

        account: {
        	code: null,
        	description: null,
        	number: null
        },
        openModalEdit: false
			}
		},

		components: {
			Layout,
		},

		created() {
			this.getAccounts()
			this.getPercUtility()
		},

		methods: {

			async getAccounts()
			{
				const resp = await AccountsApiService.get()
				this.accounts = resp.data
			},


			async updateStatus(account)
			{
				const resp = await AccountsApiService.updateStatus(account)

				if(resp.data == 'OK')
				{
					this.getAccounts()
					
					if(account.status == true)
						SwalMixin('Cuenta activada', 'success')
					else
						SwalMixin('Cuenta desactivada', 'success')
				}
				else
					SwalMixin('Ha ocurrido un error, por favor intenta de nuevo', 'error')
			},


			async updatePercUtility()
			{
				const resp = await AccountsApiService.updatePercUtility(this.percUtility)

				if(resp.data == 'OK')
					SwalMixin('Porcentaje de utilidad actualizado', 'success')
				else
					SwalMixin('Ha ocurrido un error, por favor intenta de nuevo', 'error')
			},


			async getPercUtility()
			{
				const resp = await AccountsApiService.getPercUtility()
				this.percUtility = resp.data.value
			},


			async edit(id)
			{
				const resp = await AccountsApiService.getOne(id)

				this.account.code = resp.data.code
				this.account.description = resp.data.description
				this.account.number = resp.data.number 

				this.openModalEdit = true
			},


			async update()
			{
				const resp = await AccountsApiService.update(this.account)

				if(resp.data == 'OK')
				{
					SwalMixin('Cantidad actualizada', 'success')
					this.openModalEdit = false
					this.getAccounts()
				}
				else
					SwalMixin('Ha ocurrido un error, por favor intenta de nuevo', 'error')
			}

		}

	}

</script>